import React, { PureComponent } from 'react';
import Common from './common';
import PNIGrid from './pni-grid';
import { PniNewDescription, PniNewModalContent, PniOldDescription, PniOldModalContent } from '../../utils/constants'

class PNI extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      description: this.props.shouldShowUpdatedAdsTerms ? PniNewDescription : PniOldDescription,
      modalContent: this.props.shouldShowUpdatedAdsTerms ? PniNewModalContent : PniOldModalContent,
    };
  }

  render() {
    return <div className='pni-plan'>
      <Common
        id="pni-prp"
        title='Promotional No-Interest Plans (Waived Interest, Payment Required)'
        boxText='Select the maximum plan term your practice wants to offer.'
        subTitle='Revolving Line of Credit'
        description={this.state.description}
        modalContent={this.state.modalContent}
        noInterestPlan={true}
      />
      <PNIGrid {...this.props} />
    </div>;
  }
}

export default PNI;

